import { useState } from "react";
import { Link } from "react-router-dom";
import { FolderOpen, X, Users } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { listLocalDrafts, forgetDraft, listLocalTeams } from "../../lib/api";

export const DraftsDialog = ({ open, onClose, onOpen }) => {
  const [code, setCode] = useState("");
  const [, refresh] = useState(0);
  const drafts = open ? listLocalDrafts() : [];
  const teams = open ? listLocalTeams() : [];
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg rounded-none" data-testid="drafts-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black uppercase">My drafts</DialogTitle>
          <DialogDescription>Drafts saved on this device. Use a draft code to open one from elsewhere.</DialogDescription>
        </DialogHeader>
        <div className="max-h-72 space-y-2 overflow-y-auto">
          {drafts.length === 0 && <p className="py-6 text-center text-sm text-slate-500" data-testid="drafts-empty">No drafts saved yet.</p>}
          {drafts.map((d) => (
            <div key={d.id} className="flex items-center gap-2 border-2 border-slate-200 p-2 hover:border-slate-900" data-testid={`draft-row-${d.id}`}>
              <button type="button" onClick={() => onOpen(d.id)} className="flex min-w-0 flex-1 items-center gap-3 text-left" data-testid={`draft-open-${d.id}`}>
                <FolderOpen className="h-4 w-4 shrink-0" />
                <span className="min-w-0">
                  <span className="block truncate font-bold">{d.title}</span>
                  <span className="font-mono-cc text-xs text-slate-500">{d.id} · {new Date(d.updated_at).toLocaleString("en-IE")}</span>
                </span>
              </button>
              <button type="button" aria-label="Remove from list" onClick={() => { forgetDraft(d.id); refresh((n) => n + 1); }}
                className="p-1 text-slate-400 hover:text-red-600" data-testid={`draft-forget-${d.id}`}><X className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
        {teams.length > 0 && (
          <div className="space-y-2 border-t pt-3">
            <div className="eyebrow">My squads</div>
            <div className="flex flex-wrap gap-2">
              {teams.map((t) => (
                <Link key={t.id} to={`/team/${t.id}`} onClick={onClose} data-testid={`squad-link-${t.id}`}
                  className="flex items-center gap-1.5 border-2 border-slate-900 px-3 py-1.5 text-sm font-bold hover:bg-slate-900 hover:text-white"><Users className="h-4 w-4" /> {t.name}</Link>
              ))}
            </div>
          </div>
        )}
        <form className="flex gap-2 border-t pt-4" onSubmit={(e) => { e.preventDefault(); if (code.trim()) onOpen(code.trim()); }}>
          <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Draft code" data-testid="draft-code-input"
            className="font-mono-cc flex-1 border-2 border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-900" />
          <button type="submit" className="btn-blaze px-4 py-2 text-sm" data-testid="draft-code-open-button">Open</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
